import type { SerializedMeterModel } from '@enmon/commons/lib/tools';
import type { OutputTechnology } from '@enmon/commons/lib/tools/types';
import { readInbuiltOutputTechnologies } from '@/features/inventorization/domain/inventorization-technical';
import type { LocationBootstrapMeterModel } from '@/features/location-bootstrap/location-bootstrap-types';

export interface MeterModelCatalogItem {
  id: string;
  inbuiltOutputs: OutputTechnology[];
  manufacturerId: string;
  manufacturerName: string;
  commodity: SerializedMeterModel['commodity'] | '';
  name: string;
}

export function createMeterModelCatalogItemFromBootstrapModel(
  model: LocationBootstrapMeterModel,
): MeterModelCatalogItem {
  return {
    id: String(model.id),
    inbuiltOutputs: readInbuiltOutputTechnologies(model.details),
    manufacturerId: String(model.manufacturer?.id ?? ''),
    manufacturerName: model.manufacturer?.name ?? '',
    commodity: model.commodity ?? '',
    name: model.name,
  };
}
